import { 
    call,
    put,
    takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* financialStatementData(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `financial-statements-period/${action.payload?.id}`);

    const financialStatements = res?.data?.data;
    const statementIds = financialStatements.map(statement => statement.id)

    yield put({
      type: Constants.GLOBAL_FINANCIAL_STATEMENT_DATA_SUCCESS,
      payload: {
        statementIds: statementIds,
        financialStatements: financialStatements
      }
    });

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, financialStatements);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchFinancialStatementData() {
  yield takeEvery(Constants.GLOBAL_FINANCIAL_STATEMENT_DATA_START, financialStatementData);
}
